import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    marginRight: '0.25rem',
    width: 'fit-content'
  },

  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '9px',
    fontSize: theme.size.sm,
    height: '1rem',
    width: '1rem',
    color: theme.palette.primary.main
  }
}))

export default useStyles
